<template>
  <div class="login-container">
    <div class="login-box">
      <div class="left-panel">
        <h1 class="welcome-text">Welcome Back</h1>
        <p class="sub-text">请登录您的账户</p>
      </div>
      
      <div class="right-panel">
        <form @submit.prevent="handleSubmit" class="login-form">
          <div class="form-group">
            <label for="username">用户名</label>
            <input
              type="text"
              id="username"
              v-model="form.username"
              @input="clearError"
              placeholder="请输入用户名"
              :class="{ 'error': error }"
            />
          </div>

          <div class="form-group">
            <label for="password">密码</label>
            <input
              type="password"
              id="password"
              v-model="form.password"
              @input="clearError"
              placeholder="请输入密码"
              :class="{ 'error': error }"
            />
            <div v-if="error" class="error-msg">{{ error }}</div> <!-- 显示错误信息 -->
          </div>

          <button type="submit" class="login-btn" :disabled="loading">
            <span v-if="!loading">立即登录</span>
            <div v-else class="loader"></div>
          </button>

          <div class="additional-options">
            <router-link to="/forgot-password">忘记密码？</router-link>
            <router-link to="/register">立即注册</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import loginApi from '../api/login'
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      error: null
    }
  },
  methods: {
    handleSubmit() {
      if (!this.validateForm()) return
      
      this.loading = true
      this.error = null
      
      loginApi.login(this.form.username, this.form.password)
      .then(response => {
        //console.log('登录响应:', response)
        // 确保响应包含有效数据
        if (response.code === 1) { // 根据实际成功状态码调整
          this.error = response.message
        } else if (response.code === 0) {
          // 正确获取token（根据实际返回数据结构调整）
          const token = response.data.token
          this.$store.dispatch('login', token)
          this.$router.push('/addPage')
        }
        
      })
      .catch(error => {
        console.error('登录错误:', error)
        
        // 优先使用后端返回的错误信息
        if (error.response?.data?.message) {
          this.error = error.response.data.message
        } 
        // 处理网络错误
        else if (!error.response) {
          this.error = '网络连接异常，请检查网络'
        }
        // 处理其他HTTP错误
        else {
          this.error = `系统错误（${error.response.status}）`
        }
      })
      .finally(() => {
        this.loading = false
        this.form.password = ''
      })
  },
    validateForm() {
      if (!this.form.username.trim()) {
        this.error = '请输入用户名'
        return false
      }
      if (!this.form.password) {
        this.error = '请输入密码'
        return false
      }
      return true
    },
    clearError() {
      this.error = null
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-box {
  background: white;
  border-radius: 20px;
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
  display: flex;
  max-width: 900px;
  width: 100%;
  overflow: hidden;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    min-height: 500px;
  }
}

.left-panel {
  flex: 1;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  .welcome-text {
    font-size: 2.5rem;
    margin-bottom: 15px;
    font-weight: 600;
  }

  .sub-text {
    font-size: 1.1rem;
    opacity: 0.9;
  }
}

.right-panel {
  flex: 1;
  padding: 40px 30px;
  display: flex;
  align-items: center;
}

.login-form {
  width: 100%;
  max-width: 350px;
  margin: 0 auto;

  .form-group {
    margin-bottom: 25px;

    label {
      display: block;
      margin-bottom: 8px;
      color: #4a5568;
      font-weight: 500;
    }

    input {
      width: 100%;
      padding: 12px 15px;
      border: 2px solid #e2e8f0;
      border-radius: 8px;
      font-size: 16px;
      transition: border-color 0.3s ease;

      &:focus {
        border-color: #667eea;
        outline: none;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
      }

      &.error {
        border-color: #fc8181;
      }
    }
  }
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    background: #5a67d8;
    transform: translateY(-1px);
  }

  &:disabled {
    background: #c3dafe;
    cursor: not-allowed;
  }
}

.error-msg {
  color: #fc8181;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;
}

.additional-options {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;

  a {
    color: #667eea;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;

    &:hover {
      color: #5a67d8;
    }
  }
}

.loader {
  width: 20px;
  height: 20px;
  border: 3px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: rotation 1s linear infinite;
  margin: 0 auto;
}

@keyframes rotation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 767px) {
  .left-panel {
    padding: 30px 20px;
    
    .welcome-text {
      font-size: 2rem;
    }
  }

  .right-panel {
    padding: 30px 20px;
  }
}
</style>